import {
  Box,
  ButtonLink,
  Column,
  Columns,
  Heading,
  Hidden,
  IconProfile,
  Stack,
  Text,
} from 'braid-design-system';

import { getConfigValues } from 'src/config';
import type { UserAccountType } from 'src/data';

interface ProfileHeaderProps {
  userAccountType: UserAccountType;
  emailAddress?: string;
}

const ProfileHeader = ({
  userAccountType,
  emailAddress,
}: ProfileHeaderProps) => (
  <Box
    paddingY="xlarge"
    paddingX={{ mobile: 'small', tablet: 'xlarge' }}
    background="brand"
    borderRadius={{ mobile: 'none', tablet: 'large' }}
    id="profile-page-header"
  >
    <Columns space="small" alignY="center">
      <Column width="content">
        <Heading level="1">
          <IconProfile />
        </Heading>
      </Column>

      <Column>
        <Stack space="medium">
          <Box id="profile-page-header-text">
            <Heading weight="weak" level="2">
              My profile
            </Heading>
          </Box>
          <Box id="profile-page-header-buyer-email">
            <Text>{emailAddress}</Text>
          </Box>
        </Stack>
      </Column>

      <Column width="content">
        {userAccountType === 'Buyer' && (
          <Hidden below="tablet">
            <ButtonLink
              id="profile-page-header-onboarding-button"
              variant="ghost"
              tone="neutral"
              href={`${getConfigValues().HEADER_SERVER_BASE}/onboarding?ima=private-seller`}
            >
              Sell your business
            </ButtonLink>
          </Hidden>
        )}
      </Column>
    </Columns>
  </Box>
);

export default ProfileHeader;
